<template>
  <svg
    width="208"
    height="172"
    viewBox="0 0 104 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.9936 0H17.2007C7.70103 0 0 7.70103 0 17.2007V68.7928C0 78.2925 7.70103 85.9936 17.2007 85.9936H85.9936C95.4933 85.9936 103.194 78.2925 103.194 68.7928V17.2007C103.194 7.70103 95.4933 0 85.9936 0Z"
      fill="#0B132B"
    />
    <g style="mix-blend-mode:hard-light">
      <path
        d="M103.194 17.1906L93.2424 19.671C66.4744 26.1706 39.3217 32.6804 13.0094 38.9877C8.66617 40.0304 4.32296 41.0732 0 42.1059V17.1906C0 7.68414 7.70439 0 17.2109 0H86.0037C95.5101 0 103.194 7.69427 103.194 17.1906Z"
        fill="url(#paint0_linear_9_1116)"
      />
    </g>
    <path
      d="M33.5712 58.3447C39.2687 58.3447 43.8875 53.7259 43.8875 48.0283C43.8875 42.3307 39.2687 37.7119 33.5712 37.7119C27.8736 37.7119 23.2548 42.3307 23.2548 48.0283C23.2548 53.7259 27.8736 58.3447 33.5712 58.3447Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.5712 53.1927C36.4228 53.1927 38.7345 50.8811 38.7345 48.0295C38.7345 45.1779 36.4228 42.8662 33.5712 42.8662C30.7196 42.8662 28.408 45.1779 28.408 48.0295C28.408 50.8811 30.7196 53.1927 33.5712 53.1927Z"
      fill="#A6F4D8"
    />
    <path
      d="M19.7947 33.6821C19.1771 33.6821 18.5494 33.4493 18.0837 32.9734C17.1321 32.0218 17.1321 30.493 18.0837 29.5414C21.8398 25.7854 26.8208 23.6593 32.1258 23.5479C33.4419 23.4872 34.5758 24.5806 34.6062 25.9271C34.6365 27.2635 33.5735 28.3771 32.227 28.4075C28.1774 28.4986 24.3708 30.1184 21.5158 32.9835C21.04 33.4594 20.4224 33.6922 19.7947 33.6922V33.6821Z"
      fill="#4CE0B3"
    />
    <path
      d="M83.3994 37.7938C84.0169 37.7938 84.6446 37.5609 85.1103 37.0851C86.062 36.1335 86.062 34.6047 85.1103 33.6531C81.3543 29.8971 76.3733 27.771 71.0683 27.6596C69.7522 27.5989 68.6183 28.6923 68.5879 30.0388C68.5575 31.3752 69.6206 32.4888 70.9671 32.5192C75.0167 32.6103 78.8233 34.2301 81.6783 37.0952C82.1541 37.5711 82.7717 37.8039 83.3994 37.8039V37.7938Z"
      fill="#4CE0B3"
    />
    <path
      style="mix-blend-mode:screen"
      opacity="0.68"
      d="M16.8156 47.7858C16.9371 34.8574 24.5403 24.4094 33.7936 24.4398C43.047 24.4803 50.4477 34.989 50.3262 47.9275C50.2047 60.8559 42.6015 71.3039 33.3482 71.2736C24.0948 71.2331 16.6941 60.7243 16.8156 47.7858Z"
      fill="url(#paint1_radial_9_1116)"
    />
    <path
      d="M85.9936 2.42977C94.1434 2.42977 100.765 9.06101 100.765 17.2007V68.8029C100.765 76.9528 94.1333 83.5739 85.9936 83.5739H17.2007C9.05088 83.5739 2.42976 76.9427 2.42976 68.8029V17.2007C2.42976 9.05089 9.06101 2.42977 17.2007 2.42977H85.9936ZM85.9936 0H17.2007C7.70439 0 0 7.70439 0 17.2007V68.8029C0 78.2993 7.70439 86.0037 17.2007 86.0037H85.9936C95.4899 86.0037 103.194 78.2993 103.194 68.8029V17.2007C103.194 7.70439 95.5 0 85.9936 0Z"
      fill="#0B132B"
    />
    <g filter="url(#filter0_f_9_1116)">
      <path
        d="M74 41L62 48L74 55"
        stroke="#4CE0B3"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <path
      d="M74 41L62 48L74 55"
      stroke="#4CE0B3"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M74 41L62 48L74 55"
      stroke="#A6F4D8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_f_9_1116"
        x="55.5"
        y="34.4996"
        width="25.0004"
        height="27.0007"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_9_1116"
        />
      </filter>
      <linearGradient
        id="paint0_linear_9_1116"
        x1="125.012"
        y1="-14.9633"
        x2="18.5675"
        y2="22.8601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2853E1" />
        <stop
          offset="1"
          stop-color="#2853E1"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.6114 47.5836) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
